"use strict";
// packages/types/src/recordCollection.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordAttachmentType = exports.PassFailOperator = exports.RecordItemType = void 0;
var RecordItemType;
(function (RecordItemType) {
    RecordItemType["SINGLE_LINE_TEXT"] = "single_line_text";
    RecordItemType["MULTILINE_TEXT"] = "multiline_text";
    RecordItemType["NUMBER"] = "number";
    RecordItemType["DATE"] = "date";
    RecordItemType["YES_NO"] = "yes_no";
    RecordItemType["SELECT"] = "select";
    RecordItemType["COMMENT"] = "comment";
    RecordItemType["IMAGE"] = "image";
    RecordItemType["FILE"] = "file";
    RecordItemType["COOLING_PROFILE"] = "cooling_profile";
})(RecordItemType || (exports.RecordItemType = RecordItemType = {}));
var PassFailOperator;
(function (PassFailOperator) {
    PassFailOperator["GREATER_THAN"] = ">";
    PassFailOperator["LESS_THAN"] = "<";
    PassFailOperator["GREATER_THAN_OR_EQUAL"] = ">=";
    PassFailOperator["LESS_THAN_OR_EQUAL"] = "<=";
    PassFailOperator["EQUAL"] = "=";
    PassFailOperator["NOT_EQUAL"] = "!=";
})(PassFailOperator || (exports.PassFailOperator = PassFailOperator = {}));
var RecordAttachmentType;
(function (RecordAttachmentType) {
    RecordAttachmentType["CCP"] = "ccp";
    RecordAttachmentType["PROCESS_STEP"] = "processStep";
})(RecordAttachmentType || (exports.RecordAttachmentType = RecordAttachmentType = {}));
